export const defaultPageSize = 10;

export const pageSizeOptions = [defaultPageSize, 20, 50, 100];
